
import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProductsServices } from '../../../products/services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the IngredientCompPartialIngSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-providers-partial-products-selected',
    templateUrl: 'providers-partial-products-selected.html',
})
export class ProvidersPartialProductsSelectedPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public productsServices: ProductsServices,
        public globals: Globals,
        public translate: TranslateService) {

    }

    delete(element) {
        var index = this.productsServices.provider_products_array_tmp.findIndex(x => x[0] == element[0]);
        if (index >= 0) {
            this.productsServices.provider_products_array_tmp.splice(index, 1);
            this.productsServices.provider_products_array_tmp = [...this.productsServices.provider_products_array_tmp];
        }
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.delete(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/providers/providers-add-select-elements/providers-partial-products-selected/providers-partial-products-selected.ts